import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ history, store, prefetchPip, pageData, serverPages }) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.pip.path}
          errorElement={<Error />}
          element={
            <routes.pip.component prefetchPip={prefetchPip} history={history} store={store} pageData={pageData} />
          }
        />
        <Route
          exact
          path={routes.pcp.path}
          errorElement={<Error />}
          element={<routes.pcp.component history={history} store={store} pageData={pageData} />}
        />
        <Route
          exact
          path={routes.home.path}
          errorElement={<Error />}
          element={<routes.home.component history={history} store={store} pageData={pageData} />}
        />
        <Route
          exact
          path={routes.pcpItem.path}
          errorElement={<Error />}
          element={<routes.pcpItem.component history={history} store={store} pageData={pageData} />}
        />
        <Route path="/error" element={<Error />} errorElement={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  history: PropTypes.shape({}).isRequired,
  store: PropTypes.shape({}).isRequired,
  prefetchPip: PropTypes.string.isRequired,
  pageData: PropTypes.shape({}).isRequired,
};

App.defaultProps = {};
